import { render, staticRenderFns } from "./RelatorioVendas.vue?vue&type=template&id=6b7abe2d&"
import script from "./RelatorioVendas.vue?vue&type=script&lang=js&"
export * from "./RelatorioVendas.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioVendas.vue?vue&type=style&index=0&id=6b7abe2d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports